import { useRef } from "react";
import { useScroll, useTransform } from "framer-motion";
// import { ShieldCheck } from "lucide-react";
import { usePageTheme } from "../../context/PageThemeContext";
import Logo777 from "../../assets/icons/Logo777";
import paymentLogosDark from "../../assets/images/payment/payment_logos_dark.png";
import paymentLogosLight from "../../assets/images/payment/payment_logos_light.png";
import {
  Foot,
  Brand,
  Tagline,
  Links,
  FooterLink,
  PaymentBadge,
  Copy,
  BigTextWrap,
  BigText,
  // SecureNote,
  LegalLinks,
  LegalLink,
  Imprint,
  ImprintRow,
  ImprintBullet,
} from "./Footer.styles";

export default function Footer() {
  const { light } = usePageTheme();
  const footRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: footRef,
    offset: ["start end", "end end"],
  });
  const x = useTransform(scrollYProgress, [0, 1], ["20%", "-40%"]);

  return (
    <Foot $light={light} ref={footRef}>
      <Brand>
        <Logo777 color="var(--accent)" />
        <span>APPAREL</span>
      </Brand>
      <Tagline>Fortune Favors The Bold</Tagline>
      <Links>
        <FooterLink to="/shop">Shop</FooterLink>
        <FooterLink to="/atelier">Atelier</FooterLink>
        <FooterLink to="/about">About</FooterLink>
        <FooterLink to="/gallery">Gallery</FooterLink>
        <FooterLink to="/contact">Contact</FooterLink>
        <FooterLink to="/size-guide">Size Guide</FooterLink>
        <FooterLink to="/track-order">Track Order</FooterLink>
      </Links>
      <BigTextWrap>
        <BigText style={{ x }}>
          <Logo777 color="var(--accent)" />
          APPAREL
          <Logo777 color="var(--accent)" />
          APPAREL
        </BigText>
      </BigTextWrap>
      <PaymentBadge>
        <a
          href="https://www.raiffeisenbank.rs"
          target="_blank"
          rel="noopener noreferrer"
        >
          {light ? (
            <img
              src={paymentLogosLight}
              alt="Raiffeisen Bank - Visa, Mastercard, Dina"
            />
          ) : (
            <img
              src={paymentLogosDark}
              alt="Raiffeisen Bank - Visa, Mastercard, Dina"
            />
          )}
        </a>
      </PaymentBadge>
      {/* <SecureNote>
        <ShieldCheck size={14} />
        Site is protected by 3D Secure (Visa Secure and Mastercard Identity Check)
      </SecureNote> */}
      <LegalLinks>
        <LegalLink to="/terms">Terms</LegalLink>
        <LegalLink to="/privacy">Privacy</LegalLink>
        <LegalLink to="/refund">Refund</LegalLink>
        <LegalLink to="/shipping">Shipping</LegalLink>
      </LegalLinks>
      <Copy>&copy; 2026 777 APPAREL DOO. All rights reserved.</Copy>
      <Imprint>
        <ImprintRow>
          <span>PIB 115506080</span>
          <ImprintBullet>·</ImprintBullet>
          <span>MB 68418763</span>
        </ImprintRow>
      </Imprint>
    </Foot>
  );
}
